import { render } from "./CardCompany.vue?vue&type=template&id=0a318467&scoped=true"
import script from "./CardCompany.vue?vue&type=script&lang=js"
export * from "./CardCompany.vue?vue&type=script&lang=js"

import "./CardCompany.vue?vue&type=style&index=0&id=0a318467&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0a318467"]])

export default __exports__